module.exports = __webpack_public_path__ + "img/Bitdefender-Logo-BW-web.371813f9.png";